<template>
  <div class="contentBox">
    <navBox :id="navId" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader></myHeader>
      <div class="searchBox">
        <div class="search-item">
          <p>课程名称：</p>
          <input type="text" placeholder="请输入要搜索的课程名称" v-model="obj.title">
        </div>
        <div class="search-item">
          <p>课程类型：</p>
          <select v-model="obj.type">
            <option :value="item.id" v-for="item in courseList" v-bind:key="item.id">{{item.title}}</option>
          </select>
        </div>
        <div class="search-item">
          <p>课程状态：</p>
          <select v-model="obj.status">
            <option :value="item.id" v-for="item in courseStatusList" v-bind:key="item.id">{{item.title}}</option>
          </select>
        </div>
        <div class="search-item">
          <p>创建时间：</p>
          <select v-model="obj.create_time">
            <option :value="item.value" v-for="item in dateList" v-bind:key="item.id">{{item.title}}</option>
          </select>
        </div>
        <div class="btnBox">
          <button class="btn btn-search" @click="searchSub">搜索</button>
          <button class="btn btn-reset" @click="resetSub">重置</button>
        </div>
      </div>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>课程列表</p>
          <div class="btnBox">
            <button class="btn btn-add" @click="addClass('add')">添加课程</button>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="item.id">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.title">{{item.title}}</p>
              <p :title="item.cert_set_name">{{item.cert_set_name}}</p>
              <p :title="item.cert_name">{{item.cert_name}} </p>
              <p :title="item.type==1?'在线':'录播'">{{item.type==1?'在线':'录播'}}</p>
              <p :title="item.image">
                <img :src="'https://pic.bi-rong.com/'+item.image" alt="">
              </p>
              <p :title="item.status==0?'下架':'上架'">{{item.status==0?'下架':'上架'}}</p>
              <p :title="item.create_time">{{item.create_time}}</p>
              
              <p>
                <span style="color:#4C7EFB" @click="addClass('build',item)" >编辑</span>
                <span style="color:#4C7EFB" @click="removeSub(item)" >删除</span>
                <span style="color:#4C7EFB" @click="statusChange(item)" >{{item.status==1?'下架':'上架'}}</span>
                <span style="color:#4C7EFB" @click="addCourse(item)" >添加课件</span>
                <span style="color:#FF7543" @click="lookCourse(item)" >查看课件</span>
              </p>
            </div>
          </div>
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="obj.rows"
              layout="prev, pager, next, jumper"
              :total="totalPage*obj.rows">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>


    <div class="msgBox tipsBox courseTips" v-if="showType=='add' || showType=='build'" v-loading="loading" :element-loading-text="loadTxt">
      <div class="contv">
        <p class="title">{{showType=='add'?'添加课程':'编辑课程'}}</p>
        <button class="btn btn-off" @click="closeSub('add')">x</button>
        <form>
          <div class="write-txt">
            <p>课程名称：</p>
            <input type="text" placeholder="请填写课程名称" v-model="addObj.title">
          </div>
          <div class="write-txt">
            <p>课程类型：</p>
            <select v-model="addObj.type">
              <option :value="item.id" v-for="item in courseList" v-bind:key="item.id">{{item.title}}</option>
            </select>
          </div>
          <div class="write-txt">
            <p>课程封面：</p>
            <div class="imgBox">
              <div class="img" @mouseenter="imgShow" @mouseleave="imgHide" v-if="addObj.image">
                <img :src="'https://pic.bi-rong.com/'+addObj.image" alt="">
                <div class="hover" v-if="imgType">
                  <i class="el-icon-delete" @click="imgRemove"></i>
                </div>
              </div>
              <div class="upload">
                <!-- <el-upload
                  :action="url+'/ent/Upload/uploadFile'"
                  list-type="picture-card"
                  :on-preview="handlePictureCardPreviewImg"
                  :before-upload="beforeUploadImg"
                  :on-success="handleSuccessImg"
                  :on-remove="handleRemoveImg">
                  <i class="el-icon-plus"></i>
                </el-upload> -->
                <el-upload
                  :action="'https://upload.qiniup.com'"
                  :data="uploadObj" 
                  list-type="picture-card"
                  :on-preview="handlePictureCardPreviewImg"
                  :before-upload="beforeUploadImg"
                  :on-success="handleSuccessImg"
                  :on-progress="handleProgressImg"
                  :on-remove="handleRemoveImg">
                  <i class="el-icon-plus"></i>
                </el-upload>
                
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="'https://pic.bi-rong.com/'+addObj.image" alt="">
                </el-dialog>
              </div>

              <div class="txt">
                <p>1、请上传238*188尺寸的图片</p>
                <p>2、图片大小不超过2M</p>
                <p>3、支持的图片格式：jpg、png</p>
              </div>
            </div>
          </div>
          <div class="write-txt">
            <p>证书类型：</p>
            <select @change="typeChange($event.target.value)" v-model="cert_set_id">
              <option value="">请选择证书类型</option>
              <option :value="item.id" v-for="item in certificateTypeList" v-bind:key="item.id">{{item.name}}</option>
            </select>
          </div>
          <div class="write-txt">
            <p>关联证书：</p>
            <select v-model="addObj.cert_id">
              <option value="" disabled>请选择关联证书</option>
              <option :value="item.id" v-for="item in CertList" v-bind:key="item.id">{{item.name}}</option>
            </select>
          </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-sub" @click="addSub">确认</button>
          <button class="btn btn-close" @click="closeSub('add')">取消</button>
        </div>
      </div>
    </div>


    <!-- 添加课件 -->
    <div class="msgBox tipsBox courseTips " v-if="showType=='course'" v-loading="loading" :element-loading-text="loadTxt">
      <div class="contv">
        <p class="title">添加课件</p>
        <form>
          <div class="write-txt">
            <p>课件标题：</p>
            <input type="text" placeholder="请填写课件标题" v-model="courseObj.title">
          </div>
          <div class="write-txt">
            <p>课件视频：</p>
            <div class="imgBox">
              <div class="img" @mouseenter="imgShow" @mouseleave="imgHide" v-if="courseObj.content">
                <video :src="'https://pic.bi-rong.com/'+courseObj.content" alt=""></video>
                <div class="hover" v-if="imgType">
                  <i class="el-icon-delete" @click="imgRemove"></i>
                </div>
              </div>
              <div class="upload">
                <!-- <el-upload
                  :action="'https://pic.bi-rong.com'"
                  list-type="picture-card"
                  :before-upload="beforeUpload"
                  :on-preview="handlePictureCardPreview"
                  :on-progress="handleProgress"
                  :on-success="handleSuccess"
                  :on-remove="handleRemove">
                  <i class="el-icon-plus"></i>
                </el-upload> -->

                <el-upload
                  :action="'https://upload.qiniup.com'"
                  :data="uploadObj" 
                  list-type="picture-card"
                  :before-upload="beforeUpload"
                  :on-preview="handlePictureCardPreview"
                  :on-progress="handleProgress"
                  :on-success="handleSuccess"
                  :on-remove="handleRemove">
                  <i class="el-icon-plus"></i>
                </el-upload>
                
                <!-- <el-upload
                  :action="'https://upload.qiniup.com'"
                  list-type="picture-card"
                  :data="uploadObj" 
                  :before-upload="beforeVideoUpload"
                  :on-success="onVideoSuccess" 
                  :on-error="onVideoError">
                  <i class="el-icon-plus"></i>
                </el-upload> -->

                <el-dialog :visible.sync="dialogVisible">
                  <video width="100%" :src="'https://pic.bi-rong.com/'+courseObj.content" alt=""></video>
                </el-dialog>
              </div>

              
            </div>
          </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-sub" @click="courseAdd">确认</button>
          <button class="btn btn-close" @click="closeSub('course')">取消</button>
        </div>
      </div>
    </div>


    <div class="msgBox tipsBox lookCourse " v-if="showType == 'look'">
      <div class="contv">
        <p class="title">查看课件</p>
        <div class="course-list clear">
          <div class="titleList">
            <p v-for="item in courseTitle" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="course-data">
            <div class="listItem" v-for="(item,index) in courseData" v-bind:key="item.id">
              <p :title="item.title">{{item.title}}</p>
              <p :title="item.content">
                <video :src="'https://pic.bi-rong.com/'+item.content"></video>
              </p>
              <p :title="item.long">{{item.length_txt}}</p>
              <p :title="item.addTime">{{item.create_time}}</p>
              <p>
                <span style="color:#4C7EFB" @click="courseBuild(item)" >编辑</span>
                <span style="color:#4C7EFB" @click="courseRemove(item)" >删除</span>
              </p>
            </div>
          </div>
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="lookObj.page"
              :page-size="lookObj.rows"
              layout="prev, pager, next, jumper"
              :total="lookTotalPage*lookObj.rows">
            </el-pagination> 
          </div>
        </div>
        <div class="btnBox">
          <button class="btn btn-close" @click="closeSub('look')">关闭</button>
        </div>
      </div>
    </div>
  </div>


  
</template>

<script>
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import { getCourseList,getCertSetList,getCourseCertList,saveCourse,delCourse,updateCourseStatus,getCourseDetail,saveCourseSub,getCourseSubList,delCourseSub,getCourseSubDetail,getUploadToken } from "@/assets/js/api";
export default {
  name: "course",
  data() {
    return {
      navId:'6',
      uploadObj:{
        token:'',
        key:'',
      },
      obj:{
        page:1,
        rows:10,
        title:'',
        type:0,
        status:9,
        create_time:''
      },
      totalPage:1,
      courseList:[
        {id:0,title:"请选择"},
        {id:1,title:"在线课程"},
        {id:2,title:"录播课程"},
      ],
      courseStatusList:[
        {id:9,title:"请选择"},
        {id:1,title:'已上架'},
        {id:0,title:'已下架'}
      ],
      dateList:[
        {id:0,title:"请选择",value:''},
        {id:1,title:'正序',value:'asc'},
        {id:2,title:'倒序',value:'desc'}
      ],
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'课程名称'},
        {id:3,title:'证书类型'},
        {id:4,title:'证书'},
        {id:5,title:'课程类型'},
        {id:6,title:'课程封面'},
        {id:7,title:'课程状态'},
        {id:8,title:'创建时间'},
        {id:9,title:'操作'},
      ],
      dataList:[],
      showType:'',
      addObj:{
        cert_id:'',
        title:'',
        type:0,
        image:'',
      },
      imgType:false,
      url:'',
      dialogVisible:false,
      loading:false,
      loadTxt:'',
      certificateTypeList:[],
      CertList:[],

      cert_set_id:'',

      courseTitle:[
        {id:1,title:'标题'},
        {id:2,title:'课件视频'},
        {id:3,title:'视频时长'},
        {id:4,title:'创建时长'},
        {id:5,title:'操作'},
      ],
      courseData:[
        {id:1,title:'标题1',video:'https://pic.bi-rong.com/1718334913752.mp4',long:'10',addTime:'2020-20-20'},
        {id:2,title:'标题1',video:'https://pic.bi-rong.com/1718334913752.mp4',long:'10',addTime:'2020-20-20'},
      ],
      courseObj:{
        cid:'',
        title:'',
        content:'',
        length:'',
      },
      lookObj:{
        id:'',
        page:1,
        rows:10
      },
      lookTotalPage:0,
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.url = this.$refs.navBox.url;
    this.token = this.$refs.navBox.userData.token;
    this.getList();
    this.getToken();
  },
  methods: {
    getToken(){
      getUploadToken(this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          this.uploadObj.token = data.data.token
        }
      })
    },
    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },
    resetSub(){
      this.dataList = [];
      this.obj={
        page:1,
        rows:10,
        title:'',
        type:0,
        status:9,
        create_time:''
      };
      this.getList();
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      var that = this;
      if(that.showType == 'look'){
        that.lookObj.page = `${val}`;
        that.getCourseware();
      } else {
        that.obj.page = `${val}`;
        that.getList();
      }
    },
    handleRemoveImg(file, fileList) {
      this.addObj.img = '';
    },
    handlePictureCardPreviewImg(){
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleSuccessImg(response, file, fileList){
      console.log(response,'==response==')
      this.addObj.image = response.key;
      this.loading = false;
      this.uploadObj.key = '';
    },
    beforeUploadImg(file){
      this.loading = true;
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
    },
    handleProgressImg(event, file, fileList) {
      // event 是一个包含 loaded 和 total 两个属性的对象
      // console.log('上传进度', Math.round((event.loaded / event.total) * 100) + '%');
      // console.log(file.percentage.toFixed(0))
      this.loadTxt = '已上传' + file.percentage.toFixed(0) + '%';
      // this.loadTxt = '上传中，请稍后';
      // 这里可以获取到上传进度，并根据需要更新UI
    },


    handleRemove(file, fileList) {
      this.courseObj.content = '';
    },
    
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleSuccess(response, file, fileList){
      console.log(response,'==response==')
      this.courseObj.content = response.key;
      this.loading = false;
      this.uploadObj.key = '';
    },
    beforeUpload(file){
      var that = this;
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
      if (
        [
          "video/mp4",
          "video/ogg",
          "video/flv",
          "video/avi",
          "video/wmv",
          "video/rmvb"
        ].indexOf(file.type) == -1
      ) {
        this.$message.error("不支持的文件类型");
        return false;
      }

      var url = URL.createObjectURL(file);
      var audioElement = new Audio(url);
      var duration;
      audioElement.addEventListener("loadedmetadata", function(_event) {
        duration = audioElement.duration; //时长为秒，小数，182.36
        // this.$parent.$data.wDuration = parseInt(duration);
        console.log(duration);
        that.courseObj.length = duration;
        console.log(file.size / 1024 / 1024,'==before==')
      });
      
      this.loading = true;
    },
    handleProgress(event, file, fileList) {
      // event 是一个包含 loaded 和 total 两个属性的对象
      // console.log('上传进度', Math.round((event.loaded / event.total) * 100) + '%');
      // console.log(file.percentage.toFixed(0))
      this.loadTxt = '已上传' + file.percentage.toFixed(0) + '%';
      // this.loadTxt = '上传中，请稍后';
      // 这里可以获取到上传进度，并根据需要更新UI
    },

    typeChange(e){
      console.log(e)
      var that = this;
      getCourseCertList({id:e},this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.CertList = data.data;
        } else {
          that.$message(data.msg);
        }
      })
    },

    addClass(type,e){
      var that = this;
      getCertSetList(this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.certificateTypeList = data.data;
        } else {
          that.$message(data.msg);
        }
      });
      if(type == 'build'){
        that.getDetail(e);
      } else {
        that.showType = 'add';
      }
    },

    getDetail(e){
      var that = this
      getCourseDetail({id:e.id},that.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.addObj = data.data;
          that.showType = 'build';
          that.cert_set_id = data.data.cert_set_id;
          that.typeChange(data.data.cert_set_id);
          
        } else {
          that.$message(data.msg);
        }
      })
    },

    addCourse(e){
      var that = this;
      this.showType = 'course';
      this.courseObj.cid = e.id;
    },

    lookCourse(e){
      var that = this;
      this.lookObj.id = e.id;
      this.getCourseware();
    },

    getCourseware(){
      var that = this;
      getCourseSubList(this.lookObj,that.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.showType = 'look';
          that.courseData = data.data.list;
          that.lookTotalPage = data.data.total_page;
        } else {
          that.$message(data.msg);
        }
      })
    },

    courseBuild(e){
      var that = this;
      getCourseSubDetail({id:e.id},that.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.showType = 'course';
          that.courseObj={
            cid:data.data.cid,
            title:data.data.title,
            content:data.data.content,
            length:data.data.length,
            id:data.data.id
          };
        } else {
          that.$message(data.msg);
        }
      })
    },

    courseRemove(e){
      var that = this;
      delCourseSub({id:e.id},that.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('删除成功！');
          that.lookObj.page = 1;
          that.getCourseware();
        } else {
          that.$message(data.msg);
        }
      })
    },

    imgShow(){
      this.imgType = true;
    },

    imgHide(){
      this.imgType = false;
    },

    imgRemove(){
      if(this.headID == 1){
        this.ExerSet.img = '';
      } else {
        this.TestSet.img = '';
      };
    },

    courseAdd(){
      console.log(this.courseObj,'==courseObj==')
      var that = this;
      saveCourseSub(that.courseObj,that.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('添加成功！');
          that.obj.page = 1;
          that.getList();
          that.closeSub('course')
        } else {
          that.$message(data.msg);
        }
      })
    },

    courseClose(){
      this.showType = '';
    },

    addSub(){
      var that = this;
      console.log(this.addObj,'==add==')
      saveCourse(this.addObj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('成功！');
          that.showType = '';
          that.addObj={
            cert_id:'',
            title:'',
            type:0,
            image:'',
          };
          that.obj.page = 1;
          that.getList();
        } else {
          that.$message(data.msg);
        }
      })
    },

    closeSub(type){
      var that = this;
      if(type == 'add'){
        that.addObj={
          cert_id:'',
          title:'',
          type:0,
          image:'',
        };
      } else if(type == 'course'){
        that.courseObj = {
          cid:'',
          title:'',
          content:'',
          length:'',
        };
      } else if(type == 'look'){
        that.lookObj={
          id:'',
          page:1,
          rows:10
        }
      };
      that.showType = '';
    },


    removeSub(e){
      var that = this;
      delCourse({id:e.id},this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('删除成功！');
          that.obj.page = 1;
          that.getList();
        } else {
          that.$message(data.msg);
        }
      })
    },

    statusChange(e){
      var that = this;
      updateCourseStatus({id:e.id,status:!e.status},that.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('修改成功！');
          that.obj.page = 1;
          that.getList();
        } else {
          that.$message(data.msg);
        }
      })
    },

    getList(){
      var that = this;
      getCourseList(this.obj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.dataList = data.data.list;
          that.totalPage = data.data.total_page;
          console.log(that.dataList,'==that.dataList==')
        } else {
          that.$message(data.msg);
        }
      })
    },

    // 上传视频前
    beforeVideoUpload(file) {
      console.log(file)
      this.uploadObj.key = file.name; // key为上传后文件名 必填
      if (
        [
          "video/mp4",
          "video/ogg",
          "video/flv",
          "video/avi",
          "video/wmv",
          "video/rmvb"
        ].indexOf(file.type) == -1
      ) {
        this.$message.error("不支持的文件类型");
        return false;
      }
    },
    // 上传视频成功
    onVideoSuccess(res, file) {
      console.log(res, file);
      this.videoFrom.videoUrl = `后台让我拼接的前缀`+ res.key
     
    },

    onVideoError(res){
      console.log(res,'error')
    }
  },
};
</script>
<style scoped>
  
  .dataList .listItem p,
  .organiza-list p{
    width: calc( 100% / 9 );
  }

  .dataList .listItem p img{
    width: 100%;
  }

  .dataList .listItem p span{
    display: block;
    cursor: pointer;
  }

  .imgBox{
    width: 225px;
    display: inline-block;
    text-align: left;
  }

  .imgBox .img{
    width: 100px;
    display: inline-block;
    vertical-align: top;
    margin-right: 20px;
    border: solid 1px #ccc;
    border-radius: 10px;
    overflow: hidden;
  }

  .imgBox video,
  .imgBox img{
    width: 100%;
  }

  .tipsBox .contv{
    max-height: 80%;
  }

  .tipsBox .contv form{
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .lookCourse .contv{
    width: 60%;
    height: 80%;
  }

  .course-data .listItem,
  .course-list{
    font-size: 0;
  }

  .course-list{
    height: calc( 100% - 100px );
    display: block;
  }

  .course-data .listItem p{
    margin-bottom: 10px;
  }

  .course-data .listItem p,
  .course-list .titleList p{
    display: inline-block;
    vertical-align: middle;
    font-size: 14px;
    width: 20%;
    padding: 5px 10px;
    box-sizing: border-box;
  }

  .course-list .titleList p{
    font-weight: bold;
  }

  .course-data .listItem p video{
    width: 100%;
  }

  .course-data{
    height: calc( 100% - 100px );
    overflow-y: auto;
    overflow-x: hidden;
  }

  .courseTips .contv .btn-off{
    position: absolute;
    top: 10px;
    right: 20px;
    font-size: 20px;
    font-weight: bold;
    padding: 0;
    margin: 0;
    background-color: #4C7EFB;
    color: #fff;
    width: 30px;
    height: 30px;
    border-radius: 100%;
    display: none;
  } 

  .courseTips .txt{
    display: block;
  }

  .courseTips .txt p{
    display: block;
    width: 100%;
    color: #E2231A;
    font-size: 12px;
  }

  .courseTips .contv{
    overflow-y: auto;
    overflow-x: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/course/index.vue